import { JiraConnection, Team, TeamStatus } from '../../fes';

export type JiraConnectionMode = 'default' | 'dedicated' | 'disabled';

export type TeamPanelMode = 'read' | 'edit' | 'saving';

export type TeamFormState = {
  name: string;
  description: string;
  status: TeamStatus;
  installationId: string;
  jiraConnectionMode: JiraConnectionMode;
  jiraBaseUrl: string;
};

export const teamStatuses: TeamStatus[] = ['active', 'inactive', 'suspended'];

export const jiraProjectKeyPattern = /^[A-Z][A-Z0-9_]{1,9}$/;

export const emptyTeamForm: TeamFormState = {
  name: '',
  description: '',
  status: 'active',
  installationId: '',
  jiraConnectionMode: 'default',
  jiraBaseUrl: '',
};

export function isTeamStatus(status: Team['status']): status is TeamStatus {
  return teamStatuses.includes(status as TeamStatus);
}

export function teamToForm(team: Team): TeamFormState {
  const jiraConnectionMode = effectiveJiraConnectionMode(team.jiraConnection);
  return {
    name: team.name || '',
    description: team.description || '',
    status: isTeamStatus(team.status) ? team.status : 'active',
    installationId: typeof team.installationId === 'number' ? String(team.installationId) : '',
    jiraConnectionMode,
    jiraBaseUrl: jiraConnectionMode === 'dedicated' ? team.jiraConnection?.baseUrl ?? '' : '',
  };
}

/** Legacy records without mode inherit the default unless they contain an active custom URL. */
export function effectiveJiraConnectionMode(
  connection: JiraConnection | undefined,
): JiraConnectionMode {
  if (connection?.mode) return connection.mode;
  return connection?.status === 'active' && connection.baseUrl ? 'dedicated' : 'default';
}

export function formatInstallationId(installationId: Team['installationId']): string {
  return typeof installationId === 'number' ? String(installationId) : '-';
}

export function formatArray(values: string[] | undefined): string {
  return values && values.length > 0 ? values.join('\n') : '-';
}

export function formatMetadataValue(value: string | undefined): string {
  return value || '-';
}
